var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCallend = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1015_7365",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.899902,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1015_7365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.29995 16.9L1.99995 14.65C1.79995 14.45 1.69995 14.2167 1.69995 13.95C1.69995 13.6833 1.79995 13.45 1.99995 13.25C3.46662 11.6667 5.15828 10.4792 7.07495 9.6875C8.99162 8.89583 10.9333 8.5 12.9 8.5C14.8666 8.5 16.8041 8.89583 18.7125 9.6875C20.6208 10.4792 22.3166 11.6667 23.8 13.25C24 13.45 24.1 13.6833 24.1 13.95C24.1 14.2167 24 14.45 23.8 14.65L21.5 16.9C21.3166 17.0833 21.1041 17.1833 20.8625 17.2C20.6208 17.2167 20.4 17.15 20.2 17L17.3 14.8C17.1666 14.7 17.0666 14.5833 17 14.45C16.9333 14.3167 16.9 14.1667 16.9 14V11.15C16.2666 10.95 15.6166 10.7917 14.95 10.675C14.2833 10.5583 13.6 10.5 12.9 10.5C12.2 10.5 11.5166 10.5583 10.85 10.675C10.1833 10.7917 9.53328 10.95 8.89995 11.15V14C8.89995 14.1667 8.86662 14.3167 8.79995 14.45C8.73328 14.5833 8.63328 14.7 8.49995 14.8L5.59995 17C5.39995 17.15 5.17912 17.2167 4.93745 17.2C4.69578 17.1833 4.48328 17.0833 4.29995 16.9ZM6.89995 11.95C6.41662 12.2 5.94995 12.4875 5.49995 12.8125C5.04995 13.1375 4.58328 13.5 4.09995 13.9L5.09995 14.9L6.89995 13.5V11.95ZM18.9 12V13.5L20.7 14.9L21.7 13.95C21.2166 13.5167 20.75 13.1417 20.3 12.825C19.85 12.5083 19.3833 12.2333 18.9 12Z",
    fill: "#757575"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCallend, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/callend.5e1a88b6.svg";
export { ForwardRef as ReactComponent };